/**
 * @author Ahmed Samer
 * @date   2019-04-01
 * @description Declaration of the support-issues-kind enum.
 * @filename support-issue-kind.ts
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 */


/**
 *
 *An enumeration of the kinds of support issues.
 * @export
 * @enum {number}
 */
export enum SupportIssueKind {
  /**
   *The issue concerns the GraphQL API.
   */
  API = "API",
  /**
   *The issue has no specific general.
   */
  OTHER = "OTHER",

  /**
   *The issue concerns website behavior.
   */
  WEBSITE_BEHAVIOR = "WEBSITE_BEHAVIOR",
  /**
   * "The issue concerns website content.
   */
  WEBSITE_CONTENT = "WEBSITE_CONTENT"
}
